import Vue from 'vue'
import { PublicClientApplication } from '@azure/msal-browser'

const DEFAULT_REDIRECT_CALLBACK = () => window.history.replaceState({}, document.title, window.location.pathname)

let instance

export const useMsal = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}) => {
  if (instance) {
    return instance
  }

  instance = new Vue({
    data() {
      return {
        loading: true,
        isAuthenticated: false,
        user: {},
        msalClient: null,
        error: null,
        token: null
      }
    },
    methods: {
      loginWithRedirect(path) {
        return this.msalClient.loginRedirect({
          scopes: [process.env.VUE_APP_SCOPE],
          state: path
        })
      }
    },
    async created() {
      this.msalClient = new PublicClientApplication({
        auth: {
          clientId: options.clientId,
          authority: options.authority,
          redirectUri: redirectUri,
          postLogoutRedirectUri: window.location.origin
        }
      })
      try {
        const appState = await this.msalClient.handleRedirectPromise()
        this.error = null
        if (appState !== null) {
          onRedirectCallback(appState)
        }
      } catch (err) {
        this.error = err
      }

      let currentUser = this.msalClient.getAllAccounts()

      if (currentUser.length > 0) {
        this.isAuthenticated = true
        this.user = currentUser[0]
      }
      this.loading = false
    }
  })

  return instance
}

export const MsalPlugin = {
  install(Vue, options) {
    Vue.prototype.$auth = useMsal(options)
  }
}
